import React from "react";
import SubscriptionContextModel from "./subscriptionContextModel";

const SubscriptionContext = React.createContext<SubscriptionContextModel>(
  new SubscriptionContextModel()
);
SubscriptionContext.displayName = "SubscriptionContext";

export default SubscriptionContext;
